import { render, staticRenderFns } from "./ProductConfigurationSelector.vue?vue&type=template&id=8f3869da&scoped=true"
import script from "./ProductConfigurationSelector.vue?vue&type=script&lang=js"
export * from "./ProductConfigurationSelector.vue?vue&type=script&lang=js"
import style0 from "./ProductConfigurationSelector.vue?vue&type=style&index=0&id=8f3869da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3869da",
  null
  
)

export default component.exports